<template>
<div>
   <router-view name="nestedMenu"></router-view>
</div>
</template>

<script>
export default {
   created() {
	  this.setColor("purple");
  },

  methods: {
   
	setColor(color) {
      this.$store.state.app.color = color;
    },
  }
}
</script>

<style>

</style>